import HandTalkWidget, { activateHandTalk } from './HandTalkWidget'

export default HandTalkWidget
export { activateHandTalk }
